<template>
  <div>
    <span class="text-lg font-bold">待选择项</span>
    <div class="mt-3">
      <el-input
        v-model="tableSearchWord"
        placeholder="搜索"
        clearable
        @keyup.enter.native="filterTable"
        @input="filterTable"
        @clear="filterTable"
      >
        <i slot="suffix" class="pr-1" @click="filterTable">
          <svg-icon icon-class="input_search" class="cursor-pointer"></svg-icon>
        </i>
      </el-input>
    </div>
    <general-table ref="generalTable" v-bind="$attrs" :multi="multi" v-on="$listeners">
      <template v-for="(index, name) in $scopedSlots" #[name]="slotScope">
        <slot :name="name" v-bind="slotScope"></slot>
      </template>
    </general-table>
  </div>
</template>

<script>
export default {
  name: "RcGeTable",
  props: {
    multi: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      tableSearchWord: ""
    };
  },
  methods: {
    filterTable() {
      this.$emit("tableSearch", this.tableSearchWord);
    },
    toggleRowSelection(...args) {
      return this.$refs.generalTable.toggleRowSelection(...args);
    },
    clearSelection() {
      return this.$refs.generalTable.clearSelection();
    },
    getSelection() {}
  }
};
</script>
